// extracted by mini-css-extract-plugin
module.exports = {"loader__wrapper":"styles_loader__wrapper__C92vr","loader":"styles_loader__Pl_47","load1":"styles_load1__eyeFN"};